import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "../api/client.ts";

interface AuditEntry {
  id: string;
  timestamp: string;
  user: string;
  action: string;
  resource_type: string;
  resource_id: string | null;
  ip_address: string | null;
  entry_hash: string;
  prev_hash: string | null;
}

interface AuditList {
  items: AuditEntry[];
  total: number;
  limit: number;
  offset: number;
}

export default function AuditPage() {
  const { data } = useQuery({
    queryKey: ["audit"],
    queryFn: () => apiFetch<AuditList>("/audit?limit=200"),
  });
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Audit log</h1>
        <a className="btn-secondary" href="/api/v1/audit/export.csv">Export CSV</a>
      </div>
      <div className="card p-0 overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="border-b border-slate-200 bg-slate-50 text-left uppercase text-slate-500">
            <tr>
              <th className="px-3 py-2">When</th>
              <th className="px-3 py-2">Who</th>
              <th className="px-3 py-2">Action</th>
              <th className="px-3 py-2">Resource</th>
              <th className="px-3 py-2">IP</th>
              <th className="px-3 py-2">Hash</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data?.items.map((e) => (
              <tr key={e.id}>
                <td className="px-3 py-1.5 text-slate-500">{new Date(e.timestamp).toLocaleString()}</td>
                <td className="px-3 py-1.5">{e.user}</td>
                <td className="px-3 py-1.5 font-mono">{e.action}</td>
                <td className="px-3 py-1.5">{e.resource_type}{e.resource_id ? `:${e.resource_id.slice(0, 8)}…` : ""}</td>
                <td className="px-3 py-1.5">{e.ip_address ?? "—"}</td>
                <td className="px-3 py-1.5 font-mono text-slate-400">{e.entry_hash.slice(0, 10)}…</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
